import React from 'react';
import { useSelector } from 'react-redux';
import { scaleImage } from '@nykaa/image-utils';
import styled from 'App/styled';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { PRODUCT_IMG_V2 } from 'constants/experiments';
import { State } from 'store/types';

interface SearchImageProps {
  imageV2?: string;
  IconComponent: React.ReactNode;
  showImg?: boolean;
}

const ProductImage = styled.div`
  margin-right: ${({ theme }) => theme.spacing.spacing40};
  height: 32px;
  width: 32px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: ${({ theme }) => theme.borders.radius20};
    border: 1px solid #d8d8d8;
  }
`;

function SearchImage({
  imageV2,
  IconComponent,
  showImg = true,
}: SearchImageProps) {
  const productImgVariant = useSelector((state: State) =>
    getEligibleForVariant(state, PRODUCT_IMG_V2, 'A')
  );

  const showProductImages = !!(imageV2 && productImgVariant && showImg);

  if (showProductImages) {
    const { src, srcSet } = scaleImage({
      url: imageV2,
      width: 100,
    });

    return (
      <ProductImage>
        <img
          src={src}
          srcSet={srcSet}
          alt=""
          loading="lazy"
        />
      </ProductImage>
    );
  }

  return <>{IconComponent}</>;
}

export default SearchImage;
